import { FC, Suspense } from 'react'

import { CatchBoundary, Outlet } from '@tanstack/react-router'

import { Typography } from '@forto-dev/phoenix-ui-core/common'
import { Layout } from '@forto-dev/phoenix-ui-core/ship'
import { useLocalisation } from '@forto-dev/platform-localisation'

import { createErrorFallback } from '@/fragments/create-error-fallback'
import { Footer } from '@/fragments/footer'
import { Header } from '@/fragments/header'
import { Navigation } from '@/fragments/navigation'
import { WidgetSkeleton } from '@/fragments/widgetSkeleton'

import { QuotesSidebar } from './quotesSidebar'

export const QuotesLayout: FC = () => {
  const { translate } = useLocalisation()

  return (
    <Layout
      header={<Header />}
      navigation={<Navigation />}
      sidebar={
        <CatchBoundary
          getResetKey={() => 'quotesSidebar'}
          errorComponent={createErrorFallback('An error occurred while loading widgets')}
        >
          <Suspense fallback={<WidgetSkeleton count={1} />}>
            <QuotesSidebar />
          </Suspense>
        </CatchBoundary>
      }
      title={<Typography variant="h4">{translate('navigation.quotes')}</Typography>}
      main={<Outlet />}
      footer={<Footer />}
    />
  )
}
